import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger"];

  static values = {
    // CSS class to add to trigger target when its dropdown is visible
    // TODO: this is an inflexible hack
    indicatorClass: { type: String, default: "" },
  }  

  connect() {
    this.triggerTargets.forEach(trigger => {
      const dropdownId = trigger.dataset.flowbiteDropdownId;
      const dropdownContents = document.getElementById(dropdownId);

      const options = {
        placement: "bottom-start",
        onHide: () => {
          this.updateIndicator(trigger, false);
        },
        onShow: () => {
          this.updateIndicator(trigger, true);
        }
      };

      new Dropdown(dropdownContents, trigger, options)
    }); 
  }

  updateIndicator(trigger, dropdownVisible) {
    if (this.indicatorClassValue) {
      trigger.classList.toggle(this.indicatorClassValue, dropdownVisible);
    }
  }
}